export type FunnelEvent = 'studio_open' | 'item_added' | 'add_to_cart' | 'ordered';
export type FunnelCounts = Record<FunnelEvent, number>;

export interface ProductRow extends FunnelCounts {
  product_id: number;
  name: string;
}

export interface TopRow {
  key: string;
  label: string;
  hits: number;
  thumb?: string;
}

export interface AnalyticsSummary {
  days: number;
  since: string;
  totals: FunnelCounts;
  series: Record<string, Partial<FunnelCounts>>;
  products: ProductRow[];
  top: { clipart: TopRow[]; font: TopRow[]; template: TopRow[] };
}

type VeyopHttp = { request<R>(path: string, options?: RequestInit): Promise<R> };

/** Relative routes: the host runtime maps them to WordPress REST, OpenCart or PrestaShop. */
function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const http = (window as Window & { Veyop?: { http?: VeyopHttp } }).Veyop?.http;
  if (!http) return Promise.reject(new Error('Veyo runtime is not loaded.'));
  return http.request<T>(path, {
    ...options,
    headers: {
      Accept: 'application/json',
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers ?? {}),
    },
  });
}

export function fetchSummary(days: number): Promise<AnalyticsSummary> {
  return request<AnalyticsSummary>(`analytics/summary?days=${encodeURIComponent(String(days))}`);
}

export function track(event: 'studio_open' | 'item_added', productId: number): Promise<unknown> {
  return request('analytics/track', { method: 'POST', body: JSON.stringify({ event, product_id: productId }) });
}
